<template>
  <div v-if="show" class="fullscreenConteiner">
      <pulse-loader style="z-index: 999999999999;" :color="'rgba(64, 137, 201, 1)'"/>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/ClipLoader.vue';

export default {
  name: "LoaderView",
  components: {
    PulseLoader,
  },
  props: {
    show: Boolean,
  },
};
</script>

<style scoped>
  .fullscreenConteiner {
    background-color: rgba(0, 0, 0, 0.751);
    position: absolute;
    width: 100%;
    max-height: 100%;
    height: 100%;
    justify-content: center;
    align-content: center;
  }
</style>